import { ContextButton } from "../../lib/ui/toolbar/buttons";
export class ToggleParcelsButton extends ContextButton {
    constructor() {
        super('file-medical', 'Add Parcel to Candidate Set', 'editButton');
        this.set_context('edit');
    }
}
